import { render, staticRenderFns } from "./DashboardPanel2020.vue?vue&type=template&id=412923a0&scoped=true&"
import script from "./DashboardPanel2020.vue?vue&type=script&lang=js&"
export * from "./DashboardPanel2020.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPanel2020.vue?vue&type=style&index=0&id=412923a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412923a0",
  null
  
)

export default component.exports